export const validIccCategories = (currentField, previousField, isMaxValue) => {
  return compareFields(currentField, previousField, isMaxValue);
};

export const validIccSubcategories = (currentField, previousField, isMaxValue) => {
  return compareFields(previousField, currentField, !isMaxValue);
};

function compareFields(firstField, secondField, isMaxValue) {
  if (isMaxValue) {
    return parseFloat(firstField, 10) <= parseFloat(secondField, 10);
  }
  return parseFloat(firstField, 10) < parseFloat(secondField, 10);
}

const getNumberInThousandsFormat = (number, decimals) => {
  const sign = number < 0 ? '-' : '';
  const numberComponents = Math.abs(number).toFixed(decimals).split('.');
  numberComponents[0] = numberComponents[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${sign}${numberComponents.join('.')}`;
};

export const getNumericValue = (number, decimals) => {
  if (!number || isNaN(Number(number))) {
    return 0;
  }
  return getNumberInThousandsFormat(number, decimals);
};

export const isIntegerNumber = (value) => {
  if (!value) {
    return false;
  }
  const regexp = /^-?[0-9]+$/;
  return regexp.test(value);
};

export const getNumberWithoutCommas = (value) => {
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(',', '');
  return parts.join('.');
};

export const isNumWithMaxNDecimals = (value, maxDecimals) => {
  if (!value) {
    return false;
  }
  const regexp = new RegExp(`^\\d+(\\.\\d{0,${maxDecimals}})?$`);
  return regexp.test(value);
};


export const validateEmail = (email) => {
  // eslint-disable-next-line max-len
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const checkNegativeValues = (value) => {
  if (Array.isArray(value)) {
    return value.some(
      (element) =>
        parseInt(element, 10) < 0 || isNaN(parseInt(element, 10))
    );
  }
};

export const checkNotFilledValues = (values, requiredFields) => {
  return requiredFields.some((field) => !values[field]);
};
